import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Rubro } from "@/shared/types/rubro";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteRubro(id: string): Promise<Rubro> {
    await sleep(1000);
    const response = await api.delete("rubros/" + id);
    return response.data;
}

export function useDeleteRubroMutation(id: string, mutationConfig: MutationConfig<Rubro> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteRubro(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["rubros"] });
        },
    })
}

export interface DeleteRubroMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Rubro>,
    children?: (mutationResult: MutationResult<Rubro>) => ReactNode
}

export function DeleteRubroMutation({
    id,
    children,
    mutationConfig
}: DeleteRubroMutationProps) {
    const mutationResult = useDeleteRubroMutation(id, mutationConfig);
    return children && children(mutationResult)
}